import React from 'react';
import { Link } from 'react-router-dom';
import './col.css';
import BlankBlock from '../text-block/blank-block';

const Col = ({ primaryText = '', secondaryText, primaryColor = '', secondaryColor = '', isLink = false, url = '', loading = false, showButton = false, primaryTextButton = '', actions = {}, action = '', item = {}, showFlag, openModalChangeToInspection = () => {}, isChangeToPresential= {title: ''}, isViewer, isCancel }) => {
    if (loading) {
        return <td><BlankBlock /></td>;
    }
    const onClickLink = (e) => {
        if (action) {
            actions[action](item, e);
        }
    };
    if (isCancel) {
        return (
            <td>
                {
                    <div>
                        {primaryText && <div className={primaryColor} style={{cursor: 'pointer'}}>{primaryText}</div>}
                        {secondaryText && <div className={secondaryColor}>{secondaryText}</div>}
                    </div>
                }
            </td>
        );
    }
    if (isViewer) {
        return (
            <td>
                {
                    <div>
                        {primaryText && <div className={primaryColor} onClick={(isLink && isChangeToPresential.state === 1) ? openModalChangeToInspection.bind(this, isChangeToPresential): null} style={{cursor: 'pointer'}}>{primaryText}</div>}
                        {secondaryText && <div className={secondaryColor}>{secondaryText}</div>}
                    </div>
                }
            </td>
        );
    }
    return (
        <td>
            {
                (isLink && isChangeToPresential.state === 0) ?
                    <Link to={url} onClick={onClickLink}>
                        {primaryText && <div className={primaryColor}>{primaryText}{showFlag && <div className="text-white doctorReview"><span>M</span></div>}</div>}
                        {secondaryText && <div className={secondaryColor}>{secondaryText}</div>}
                    </Link>
                    :                     
                    <div>
                        {primaryText && <div className={primaryColor} onClick={(isLink && isChangeToPresential.state === 1) ? openModalChangeToInspection.bind(this, isChangeToPresential): null} style={{cursor: 'pointer'}}>{primaryText}</div>}
                        {secondaryText && <div className={secondaryColor}>{secondaryText}</div>}
                    </div>
            }
        </td>
    );
};

export default Col;



// WEBPACK FOOTER //
// ./src/components/shared/table/col.jsx